import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

const PREFIX = 'PricingInfo';

const classes = {
	root: `${PREFIX}-root`,
	icon: `${PREFIX}-icon`,
	colorBox: `${PREFIX}-colorBox`,
};

const StyledBox = styled(Box)(({ theme }) => ({
	[`&.${classes.root}`]: {
		display: 'flex',
		alignItems: 'center',
		margin: theme.spacing(0, 3, 0, 0),
	},

	[`& .${classes.icon}`]: {
		paddingRight: theme.spacing(0.9),
	},

	[`& .${classes.colorBox}`]: {
		padding: '3px',
		borderRadius: '50%',
		marginRight: '11px',
	},
}));

interface PricingInfoProps {
	className?: string;
	pricingName?: string;
	infoLable?: string;
	styles?: string;
	bColor?: string;
}

const PricingInfo = (props: PricingInfoProps) => {
	const { className, pricingName, bColor } = props;

	return (
		<StyledBox className={clsx(classes.root, className)}>
			<Box bgcolor={bColor} className={classes.colorBox} />
			<Typography className={classes.icon}>{pricingName}</Typography>
		</StyledBox>
	);
};

export default PricingInfo;
